import * as React from "react";
import { Field } from "react-form";
import Toggle from "react-toggle";

const Switch = props => (
  // Use the form field and your custom input together to create your very own input!
  <Field field={props.field}>
    {fieldApi => {
      const { onChange, onBlur, field, ...rest } = props;
      const { value, error, warning, success, setValue, setTouched } = fieldApi;
      return (
        <Toggle
        // checked={value}
        name={field}
        defaultChecked={value}
        onChange={(e) => { const v = e.target.checked; setValue(v ? 1 : 0); } }
        />
      );
    }}
  </Field>
);

export { Switch };



// WEBPACK FOOTER //
// ./src/services/form.tsx